import { store } from '@/store'
import { NavigationGuardNext, Route } from 'vue-router'
import { getDeepLinkParams } from './router-helpers'

/**
 * AuthGuard
 * 
 * Check if the user is logged in.  If a permission is set, check that the user
 * has greater than or equal permission.
 */
const AuthGuard = (to: Route, from: Route, next: NavigationGuardNext) => {
    //  Create a pass function
    const pass = () => {
        store.getters.appDebug && console.log(`GUARD: auth-guard pass...`)
        return next()
    }

    //  Create a fail function
    const fail = (path: string) => {
        store.getters.appDebug && console.log('GUARD: auth-guard stop.')
        return next(path)
    }

    //  Fetch the current user
    const user = store.getters.user

    //  If the user doesn't exist route to home page
    if (!user) {
        //  Get deep link params (if valid) for redirecting after signin
        const params = getDeepLinkParams(to)

        //  Redirect to signin
        return fail(`/signin${params}`)
    }

    //  Else, get the permission we're checking for
    const permission = to.meta.permission || 0

    //  Check if the user has permission
    let hasPermission = false

    //  Go through every single membership to see if they have a high enough permission
    //  Note: Users will now be bound to individual tenants meaning they SHOULD only have 1
    //  membership, and so they SHOULD NOT run into an instance of having a higher permission in
    //  1 tenant than the tenant they are trying to connect to. BUT IT CAN HAPPEN, WE MIGHT CHANGE IN FUTURE
    for (let i = 0; i < store.getters.user.memberships.length; i++) {
        let role = store.getters.user.memberships[i].role
        if (role.permission >= permission) hasPermission = true
    }

    //  If from.path is not from memberships OR from registration, then we want to check for permission within this tenant
    if (!from.path.includes('memberships') && !from.path.includes('register')) hasPermission = store.getters.userHasPermission(permission)
    //  Else, if we are coming from registration just check that they have a user
    else if (from.path.includes('register')) hasPermission = user != null

    //  If the user does NOT have permission, redirect to 'from'
    if (!hasPermission) return fail(from.path)

    //  Else, guard passes, continue
    return pass()
}

export default AuthGuard
